import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

export default function validateInput(data) {
  const errors = {};

  if (!Validator.isEmail(data.email)) {
    errors.email = 'Email is invalid';
  }

  if (Validator.isEmpty(data.fullName) || !/^\w+ \w+/.test(data.fullName)) {
    errors.fullName = 'Enter full name';
  }

  if (Validator.isEmpty(data.password) || data.password.length < 8) {
    errors.password = 'Password must be 8 char';
  }
  return { errors, isValid: isEmpty(errors) };
}
